import { api } from "@/lib/api";

// E-KYC
export const fetchKycStatus = () => api.get("/lawyer/kyc/status").then((r) => r.data);
export const uploadKycDocument = (formData) =>
  api.post("/lawyer/kyc/upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
export const aadhaarStartOtp = (aadhaar_number) =>
  api.post("/lawyer/kyc/aadhaar/start", { aadhaar_number }).then((r) => r.data);
export const aadhaarVerifyOtp = (reference_id, otp) =>
  api.post("/lawyer/kyc/aadhaar/verify", { reference_id, otp }).then((r) => r.data);
export const submitBci = (enrolment_number, name) =>
  api.post("/lawyer/kyc/bci/submit", { enrolment_number, name }).then((r) => r.data);
export const removeKycDocument = (docId) =>
  api.post(`/lawyer/kyc/documents/${encodeURIComponent(docId)}/remove`).then((r) => r.data);
export const digilockerStart = (docTypes) =>
  api.post("/lawyer/kyc/digilocker/start", { doc_types: Array.isArray(docTypes) ? docTypes : [docTypes] }).then((r) => r.data);
export const digilockerComplete = (ref) =>
  api.post("/lawyer/kyc/digilocker/complete", { ref }).then((r) => r.data);

// Admin KYC review
export const adminKycQueue = (params) =>
  api.get("/admin/kyc/queue", { params }).then((r) => r.data);
export const adminKycQueueGrouped = (params) =>
  api.get("/admin/kyc/queue/grouped", { params }).then((r) => r.data);
export const adminKycDocUrl = (lawyerId, docId) =>
  api.get(`/admin/kyc/${lawyerId}/document/${docId}/url`).then((r) => r.data);
export const adminKycApprove = (lawyerId, docId, note = "") =>
  api.post(`/admin/kyc/${lawyerId}/${docId}/approve`, { note }).then((r) => r.data);
export const adminKycReject = (lawyerId, docId, reason) =>
  api.post(`/admin/kyc/${lawyerId}/${docId}/reject`, { reason }).then((r) => r.data);

// Reliability
export const fetchReliability = (cid) =>
  api.get(`/consultations/${cid}/reliability`).then((r) => r.data);
